var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 11.9699H10.1667C10.5333 11.9699 10.8333 11.6699 10.8333 11.3032V5.96989C10.8333 5.60322 10.5333 5.30322 10.1667 5.30322H6.16667C5.8 5.30322 5.5 5.60322 5.5 5.96989V11.3032C5.5 11.6699 5.8 11.9699 6.16667 11.9699ZM6.16667 17.3032H10.1667C10.5333 17.3032 10.8333 17.0032 10.8333 16.6366V13.9699C10.8333 13.6032 10.5333 13.3032 10.1667 13.3032H6.16667C5.8 13.3032 5.5 13.6032 5.5 13.9699V16.6366C5.5 17.0032 5.8 17.3032 6.16667 17.3032ZM12.8333 17.3032H16.8333C17.2 17.3032 17.5 17.0032 17.5 16.6366V11.3032C17.5 10.9366 17.2 10.6366 16.8333 10.6366H12.8333C12.4667 10.6366 12.1667 10.9366 12.1667 11.3032V16.6366C12.1667 17.0032 12.4667 17.3032 12.8333 17.3032ZM12.1667 5.96989V8.63656C12.1667 9.00322 12.4667 9.30322 12.8333 9.30322H16.8333C17.2 9.30322 17.5 9.00322 17.5 8.63656V5.96989C17.5 5.60322 17.2 5.30322 16.8333 5.30322H12.8333C12.4667 5.30322 12.1667 5.60322 12.1667 5.96989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogo);
export default __webpack_public_path__ + "static/media/dashboard-logo.12342456507f29e2f3cbee271aeb07f8.svg";
export { ForwardRef as ReactComponent };